import { render } from "./XyInputTag.vue?vue&type=template&id=d873dda4"
import script from "./XyInputTag.vue?vue&type=script&lang=js"
export * from "./XyInputTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__